import React from "react";
import { useSelector } from "react-redux";
import ProductItem from "../shared/ProductItem";

function Spice() {
  const state = useSelector((state) => state);
  const filteredItems =
    state.products && state.products.filter((i) => i.category === "spices");
  return (
    <div className="main-drinks-container">
      {filteredItems.map((i) => (
        <ProductItem
          name={i.name}
          price={i.price}
          currency={i.currency}
          description={i.description}
          subcategory={i.subcategory}
        />
      ))}
    </div>
  );
}

export default Spice;
